import { PeriodMode } from '../../../enums/periodMode'
import type { PeriodValue } from '../../../types/periodValue'

/**
 * Whether a period is bounded on both ends and safe to use as the shared expert-report period. Rejects the
 * open-ended `All` mode and a custom range missing either bound, whether it came from an in-progress Custom
 * panel selection or was crafted by hand in the URL.
 */
export const isFiniteReportPeriod = (periodValue: PeriodValue | undefined): periodValue is PeriodValue => {
  if (!periodValue || periodValue.mode === PeriodMode.All) {
    return false
  }

  if (periodValue.mode === PeriodMode.CustomDate) {
    return Boolean(periodValue.customDate?.startDate) && Boolean(periodValue.customDate?.endDate)
  }

  return true
}
